module.exports = __webpack_public_path__ + "img/poisson_frais.8d7b9b71.png";